import {useContext, useMemo} from "react";

import ChannelService from "../../../services/channel";
import {HTTPContext} from "../../contexts";

export const useChannelService = () => {
    const http = useContext(HTTPContext);
    const userService = useMemo(() => new ChannelService(http), [http]);
    return userService;
};
